<top-bar-tabs></top-bar-tabs>
@if (doneLoading) {
  <div>
    <br />
    <embedded-report>
    <mat-card appearance="outlined" class="committee-header">
      <mat-card-title>
        {{ project?.name ? project?.name : "" }}
        <br />
        <small class="status"
          ><b>current status: </b>{{ info.projectStatus }}</small
          >
        </mat-card-title>
      </mat-card>
      <mat-card appearance="outlined" class="container-card">
        <mat-card-content>
          <app-committee-deal-information
          [deal]="info"></app-committee-deal-information>
          <app-committee-deal-dates [deal]="info"></app-committee-deal-dates>
          <hr />
          <committee-reports [projectId]="project.id" [project]="project">
          </committee-reports>
          <app-committee-links
            [deal]="info"
            [readOnly]="readOnly"
          [milestones]="milestones"></app-committee-links>
          <app-committee-conditions
            [projectId]="project.id"
            [readOnly]="readOnly"
            [approvalType]="itemsService.getLegalApprovalType()"
          [milestones]="milestones"></app-committee-conditions>
          @for (milestone of milestones; track milestone) {
            <app-milestone-sections
              [milestone]="milestone"
              [milestones]="milestones"
              [readOnly]="readOnly"
              [approvalTypes]="approvalTypes"
            [project]="project"></app-milestone-sections>
          }
          @for (milestone of milestones; track milestone) {
            <app-disclosures-editor
              [milestone]="milestone"
              [readOnly]="readOnly"
              (updateHTML)="recieveEditorHTML($event)"
              [project]="project"
          [disclosure]="
            disclosureForMilestone(milestone)
          "></app-disclosures-editor>
          }
          <app-committee-conditions
            title="LEGAL NOTES"
            [projectId]="project.id"
            [readOnly]="readOnly"
            [approvalType]="itemsService.getLegalApprovalType()"
            [isLegalNote]="true"
            [milestones]="milestones"
          [headerColumns]="[
            'issue',
            'milestone',
            'actions'
          ]"></app-committee-conditions>
        </mat-card-content>
      </mat-card>
    </embedded-report>
  </div>
}
